export default "__VITE_ASSET__UMaJyQhJ__"